import { Divider, Skeleton } from '@ds';
import { times } from 'lodash-es';

export const UserModalSkeleton = () => (
  <div className="flex flex-col gap-6">
    <div className="flex gap-4">
      <Skeleton className="h-24 w-24 rounded-xl" />
      <div className="flex w-full flex-col gap-2">
        <Skeleton className="w-60 h-14 rounded-lg" />
        <Skeleton className="w-96 h-8 rounded-lg" />
      </div>
    </div>
    <Divider />
    <div className="flex flex-col gap-8 mt-4">
      {times(3, (n) => (
        <div key={n} className="flex justify-between">
          {times(3, (i) => (
            <Skeleton key={i} className="w-[30%] h-12 rounded-lg" />
          ))}
        </div>
      ))}
    </div>
  </div>
);
